import moment from '../../../common/moment-timezone/moment-timezone';

import { DEFAULT_TZ } from './time.config';

/**
 * Get a moment in the default timezone.
 *
 * See https://momentjs.com/timezone/docs/#/using-timezones/parsing-in-zone/ for a description of what is
 * done to the moment when it is moved into the target timezone.
 *
 * In short:
 *
 * Arrays, strings without offset and objects are not changed, the correct offset is only added
 * to the moment. So for example time 01:00:00 will become 01:00:00+0300.
 *
 * Strings with offset are converted according to the offset. So 01:00:00Z -> 04:00:00+0300.
 *
 * Unix timestamps are treated as UTC and converted, JS dates are converted from their offset.
 *
 * Moments are just moved into the target TZ.
 *
 * @param {Array|String|Object|Number|Date|Moment} arg
 * @return {Moment}
 */
function momentDefaultTZ(arg=null) {
  if (arg == null) {
    return moment.tz(DEFAULT_TZ);
  }
  else if (moment.isMoment(arg)) {
    return arg.tz(DEFAULT_TZ);
  }

  return moment.tz(arg, DEFAULT_TZ);
}

/**
 * Sort two moments following the JavaScript sort function rules.
 *
 * Suitable for inserting into array.sort(fun).
 *
 * @param {Moment} a
 * @param {Moment} b
 */
function sortMoment(a, b) {
  return a.unix() - b.unix();
}

/**
 * Format a time as ISO 8061 Date (2017-12-24)
 * @param {Moment|Date} time
 * @return {string}
 */
function isoDate(time) {
  return momentDefaultTZ(time).format("Y-MM-D");
}

/**
 * Format a time as ISO 8061 month (2017-12)
 * @param {Moment|Date} time
 * @return {string}
 */
function isoMonth(time) {
  return momentDefaultTZ(time).format("Y-MM");
}

export {
  momentDefaultTZ,
  sortMoment,
  isoDate,
  isoMonth,
};
